import React, { useEffect } from 'react';
import { editorTypeToDisplayMap, EditorContents, EditorChangeEvent, type LegacyEditorTypeString } from './Editor';
import { useConvertDocument } from './useConvertDocument';
import Loading from "../vulcan-core/Loading";
import { Typography } from "../common/Typography";
import { defineStyles } from '@/components/hooks/defineStyles';
import { useStyles } from '@/components/hooks/useStyles';

const styles = defineStyles('LastEditedInWarning', (theme: ThemeType) => ({
  lastEditedWarning: {
    color: theme.palette.error.main,
  },
  clickHereColor: {
    color: theme.palette.primary.main
  },
}));

const LastEditedInWarning = ({autoConvert, initialType, currentType, defaultType, value, setValue}: {
  autoConvert: boolean,
  initialType: LegacyEditorTypeString,
  currentType: LegacyEditorTypeString,
  defaultType: LegacyEditorTypeString,
  value: EditorContents,
  setValue: (change: EditorChangeEvent) => void,
}) => {
  const classes = useStyles(styles);
  const {convertDocument, loading, error} = useConvertDocument({
    onCompleted: (result: EditorContents) => {
      setValue({
        contents: result,
        autosave: false,
      });
    }
  });
  
  useEffect(() => {
    if (autoConvert) {
      setTimeout(() => {
        convertDocument(value, 'lexical');
      }, 0);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoConvert]);
  
  return <div>
    {loading && <Loading/>}
    <Typography variant="body2" className={classes.lastEditedWarning}>
      This document was last saved in {editorTypeToDisplayMap[initialType].name} format.{' '}
      {autoConvert
        ? <>Converting...</>
        : <>Showing the {editorTypeToDisplayMap[currentType].name} editor.</>
      }
      {!autoConvert && <>
        <a
          className={classes.clickHereColor}
          onClick={() => {
            convertDocument(value, 'lexical');
          }}
        >
          Click here
        </a>
        {' '}to switch to the {editorTypeToDisplayMap['lexical'].name} editor (the default editor).
      </>}
    </Typography>
    <br/>
  </div>
}

export default LastEditedInWarning;


